import React, { VoidFunctionComponent } from 'react';

interface Props {
  type: string,
  borderRadius?: boolean;
}

export const PlaceholderBlock: VoidFunctionComponent<Props> = ({ type, borderRadius = false }) => (
  <div className={`placeholder-block  ${type} ${borderRadius ? 'border-radius' : ''}`}></div>
);
